//默认导入
const { ccclass, property } = cc._decorator;
import ModuleBase, { ViewLayer, moduleInit, bindButtonClickEvent } from "../../../../framework/core/mvvm/module_base";

import Utility from "../../../../utility/utility";
import DialogReceiveMangoView from "./dialog_receive_mango_view";
import ModuleManager from "../../../../framework/core/module_manager";
import FirstCharge from "../../../hall/module/firstcharge/firstcharge";
import DailySign from "../../../hall/module/dailysign/dailysign";
import { TaskModule } from "../../../hall/module/gametask/task_module";

@ccclass
@moduleInit("DialogReceiveMango")
export default class DialogReceiveMango extends ModuleBase<DialogReceiveMangoView, null> {

    scheduleCallback: Function

    constructor() {
        super();
        this.package = "public";
        this.layer = ViewLayer.High;
        this.windowPrefabResPath = "package/public/dialog_receive_mango";
        this.viewType = DialogReceiveMangoView;
        this.needViewMask = true
        this.clickAnywhereClose = false
    }

    onInit(arg) {
        super.onInit(arg)
      
    }

    public onShow(content : any){

        this.view.updateContent(content);
    }

   
    @bindButtonClickEvent("firstBtn")
    onFirstBtn(){
        ModuleManager.instance.showModule(FirstCharge)
        this.hide();
    }

    @bindButtonClickEvent("signBtn")
    onSigntBtn(){
        ModuleManager.instance.showModule(DailySign);
        this.hide();
    }

    @bindButtonClickEvent("taskBtn")
    onTaskBtn(){

        ModuleManager.instance.showModule(TaskModule);
        this.hide();
    }

    @bindButtonClickEvent("CloseBtn")
    onClose(){

        this.hide();
        this.view.hideContent();
    }
 

    
}